// @flow

import React from "react";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const Downtime = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 12 12">
            <g>
                <path d="M9.74,8.51A.87.87,0,0,1,8.51,9.74L6,7.27,3.58,9.74A.87.87,0,0,1,2.35,8.51L4.81,6,2.26,3.49A.87.87,0,0,1,3.49,2.26L6,4.73,8.42,2.26A.87.87,0,0,1,9.65,3.49L7.27,6,9.74,8.51Z" />
            </g>
        </svg>
    </SvgIcon>
);

export default Downtime;
